<div >
  <p-confirmDialog header="Confirmation" ></p-confirmDialog>
    <p-toast position="top-center"></p-toast> 
    <p-treetable [paginator]="true" [rows]="15" paginatorPosition="bottom" #variancett [value]="this.varianceNodes"
      [globalFilterFields]="['patientName']" (onNodeExpand)="onNodeExpand($event)">
  
  
      <ng-template pTemplate="header">
        <tr>
          <th class="share-col-header" style="width:85px; border-top-left-radius: 10px;">
            <p-checkbox [(ngModel)]="selectAll" name="list_name" (click)="checkUncheckAll($event)" class="SelectAllCheck" [binary]="true" style="position: relative; right:13px;"></p-checkbox>
          </th>
          <th>Patient Name</th>
          <th>Patient ID</th>
          <th>Med Description</th>
          <th>>User ID</th>
          <th>User Name</th>
          <th>Role</th>
          <th>Stock Area</th>
          <th>Quantity</th>
          <th>Unit of Measure</th>
          <th>Date/Time</th>
          <th>Transaction Type</th>
          <th style="width:190px; border-top-right-radius: 10px;">Variance Type</th> 
        </tr>
      </ng-template>
  
      <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
        <ng-container [ngSwitch]="getNodeLevel(rowNode)">
          <tr *ngSwitchCase="1" class="maap-row-level1">
            <td>
              <p-checkbox [disabled]="rowData.id === mainRecord.id" [(ngModel)]="rowData.isSelected" [binary]="true" class="share-check"></p-checkbox>
            </td>
            <td colspan="">
              <p-treetable-toggler [rowNode]="rowNode">
                <ng-template>
                </ng-template>
              </p-treetable-toggler>
              <span tabindex="0" style="cursor:pointer"
                (click)="$event.currentTarget.previousSibling.children[0].click()" (keydown.enter)="$event.currentTarget.previousSibling.children[0].click()">{{formatName(rowData.patientName)}}</span>
            </td>
            <td>{{rowData.mrnNum}}</td>
            <td>{{rowData.medGroupName}}</td>
  
            <td>{{rowData.lanId}}</td>
            <td>
              {{formatName(rowData.employeeName)}}
            </td>
            <td>{{rowData.adminGroup}}</td>
  
            <td>{{rowData.loc}}</td>
  
            <td>{{(rowData.var==="NaN" || rowData.resolutionCoding==="Pending Waste
              Reconciliation" || rowData.resolutionCoding==="Pending Assay (checking on code)"
              )?formatVarianceNotReady(rowData):rowData?.var | formatQuantity}}</td>
            <td>{{["Added Waste Reconciliation", "Waste Retrieval", "Added Waste Assay", "Assay"].includes(rowData.source)?rowData.wasteUOM2:rowData.uom}}</td>
            <td>{{rowData.varDateString|date:'MM/dd/yyyy | HH:mm'}}</td>
            <td *ngIf="rowData.transType==='Verified'"> <i ng-reflect-ng-class="pi pi-fw pi-chevron-right" class="pi pi-check pi-fw"></i> Verified</td>
            <td *ngIf="rowData.transType!=='Verified'"></td>
            <td class="position-relative">
              <div id="colorBox" [ngClass]="getResolutionBg(rowData.resolutionCoding)">
                <div class="position-relative" style="font-size: 12px; font-weight: 600; display:flex; justify-content: center;">{{ rowData?.resolutionCoding }}</div>
              </div>
              <div class="iconBox">
                <img tabindex="0"
                  class="maap-icon-Style float-right"
                  src="/assets/images/icon_edit.png"
                  alt="Edit notes"
                  (click)="showCommentEdit(rowData)" (keydown.enter)="showCommentEdit(rowData)">
              </div>
            </td>
            <!-- Wait to be able to Test it's for switching the td to have same color theme -->
            <!-- <td class="position-relative">
              <div id="colorBox" [ngClass]="getResolutionBg(rowData.resolutionCoding)">
                <div class="position-relative" style="font-size: 12px; font-weight: 600; display:flex; justify-content: center;">
                  {{ rowData?.resolutionCoding }}
                </div>
              </div>
              <div class="iconBox">
                <img tabindex="0"
                  class="maap-icon-Style float-right"
                  src="/assets/images/icon_edit.png"
                  (click)="showCommentEdit(rowData)">
              </div>
            </td> -->
          </tr>
          <tr *ngSwitchCase="2" class="maap-row-level2">
            <td colspan="13" [class]="rowClass(rowData.label)">
              <p-treetable-toggler [rowNode]="rowNode"></p-treetable-toggler>
              <span tabindex="0" style="cursor:pointer"
                (click)="$event.currentTarget.previousSibling.children[0].click()" (keydown.enter)="$event.currentTarget.previousSibling.children[0].click()">{{rowData.label}}</span>
  
            </td>
          </tr>
          <tr *ngSwitchCase="3" [class]="getChildRowClass(rowNode.parent.data.label)" class="maap-row-level3">
            <ng-container>
              <ng-container *ngIf="rowData?rowData['adminId']:false; else rowUndefined">
                <td></td>
                <td colspan="">
                  {{formatName(rowData.patientName)}}
                </td>
                <td>{{rowData.mrnNum}}</td>
                <td>{{rowData.medDesc}}</td>
                <td>{{rowData.lanId}}</td>
                <td>
                  {{formatName(rowData.employeeName)}}
                </td>
                <td>{{rowData.adminGroup}}</td>
                <td>{{rowData.loc}}</td>
                <td>{{rowData.var | formatQuantity}}</td>
                <td>{{rowData.uom}}</td>
                <td>{{rowData.varDateString|date:'MM/dd/yyyy | HH:mm'}}</td>
                <td>{{rowData.transType}}</td>
                <td [ngClass]="getResolutionBg(rowData.resolutionCoding)">{{rowData.resolutionCoding}}</td>
              </ng-container>
              <ng-template #rowUndefined>
                <td colspan="12 text-center">
                  <span class="font-weight-bold font-italic no-transaction-message">No Transaction Record!</span>
                </td>
              </ng-template>
            </ng-container>
  
          </tr>
        </ng-container>
      </ng-template>
    </p-treetable>
    <p-dialog header="View/Add New Comments and View/Update Variance Type" (onShow)="onShowModal()" (onHide)="onHideModal()" [style]="{width: '60vw'}"
      [(visible)]="commentDialog" appendTo="body" class="popUpHeader">
      <app-comment-modal #commentModal [selectedRow]="selectedRow"  (completed)="submitMessageCompleted($event)">
      </app-comment-modal>
    </p-dialog>
    <p-dialog [(visible)]="tableDataIsLoading" [showHeader]="false" [resizable]="false" [modal]="true"
          [focusOnShow]="false" class="progress-overlay"> 
      <div style="width: 200px; height: 150; padding-top: 5%" class="text-center">
          <p-progressSpinner [style]="{ width: '50px', height: '50px' }"></p-progressSpinner>
      </div>
    </p-dialog>
   
  </div>
  <p-footer>
   <div class="row">
    <div class="col-12 text-right p-2">
      <p-button label="Cancel" variant="text" severity="warn" (click)="closeDialog()"/>
      <p-button label="Remove Link" variant="text" severity="info" (click)="unLinkSelectedRecords()"/>
    </div>
   </div>
</p-footer>
